var map = {
	"./Act/resources/components/canvas/blocks/modules/act/admin/BlockPanel.vue": 49589,
	"./Event/resources/components/canvas/blocks/modules/events/admin/BlockPanel.vue": 87858,
	"./Event/resources/components/canvas/blocks/modules/events/block.js": 89696,
	"./Project/resources/components/canvas/blocks/modules/projectSlider/admin/BlockPanel.vue": 94762,
	"./Project/resources/components/canvas/blocks/modules/projectSlider/block.js": 3734
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 31335;